import { Banner, BannerAds, GetListResponse } from "@app/types";
import HttpService from "@core/services/http/http.service";
import { Signal } from "@core/services/http/http.type";

class _BannerService {
  public getList(signal?: Signal) {
    return HttpService.get<GetListResponse<Banner>>("/user/api/v2/banners", {
      signal,
    });
  }

  public getBannerAdsList(signal?: Signal) {
    return HttpService.get<GetListResponse<BannerAds>>(
      "/user/api/v2/banner-ads",
      {
        signal,
      }
    );
  }
}

const BannerService = new _BannerService();

export default BannerService;
